import { RouteMiddleware } from 'services/route';
import { isLogged } from './';

/**
 * AuthGuard is used to prevent user who is not logged in access protected page.
 */
export class AuthGuard implements RouteMiddleware {
  process(): boolean | string {
    if (isLogged()) {
      return true;
    }

    try {
      localStorage.clear();
      sessionStorage.clear();
      // eslint-disable-next-line no-empty
    } catch (e) {}

    return '/auth/login';
  }
}
